<template>
  <body style="background: #fff">
    <div>
      <Nav-bar :has_back="true" :has_right="false" title="启动中"></Nav-bar>
      <div class="top-margin"></div>
      <div class="container">
        <img src="../station/../../images/staring_dot.gif" class="dot" />
        <div class="row-layout time m-t-20">
          <span class="f60-0082ff">{{ timeCount }}<span class="unit-second">秒</span></span>
        </div>
        <div class="t-f14-c66">正在启动中，请耐心等待…</div>
        <div class="start_icon_div">
          <div class="block_v first">
            <div class="column_">
              <div class="t-f16-c40465c">启动中，请勿拔枪</div>
              <div class="t-f14-c9FA1AB m-t-5">
                启动过程中拔枪会造成订单异常
              </div>
            </div>
            <img src="@/images/charging_start_tip1.png" class="tip_icon first_i" />
          </div>
          <div class="block_v second">
            <div class="column_">
              <div class="t-f16-cff">安全提示</div>
              <div class="t-f14-cFFF1EC">1.车停好，熄火后再充电</div>
              <div class="t-f14-cFFF1EC">2.确保充电枪插好</div>
              <div class="t-f14-cFFF1EC">
                3.充电时，尽量不开空调，不停留车内
              </div>
              <div class="t-f14-cFFF1EC">4.充电完毕，及时拔枪</div>
            </div>
            <img src="@/images/charging_start_tip2.png" class="tip_icon second_i" />
          </div>
        </div>
      </div>
    </div>
  </body>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import { reactive, ref } from "vue";
import { useRouter } from "vue-router";
import { Toast, Dialog } from "vant";
import config from "@/api/config";
let state;
let router;
let rejectAnalysis = ref("");
let timeCount = ref(0);
let timeInterval = null;
let orderId;
let lockReconnect = false; //避免重复连接
let ws;
let tt;
export default {
  components: {
    NavBar,
  },
  unmounted() {
    clearDataTools();
  },
  setup() {
    state = reactive({
      list: [],
      loading: false,
      finished: false,
    });
    timeCount.value = 120;
    router = useRouter();
    orderId = router.currentRoute.value.params.id;
    countDown();
    connectWebSoket(orderId);

    return {
      state,
      connectWebSoket,
      router,
      countDown,
      timeCount,
      rejectAnalysis,
    };
  },
};
function countDown() {
  if (timeInterval == null) {
    timeInterval = setInterval(() => {
      if (timeCount.value <= 60) {
        clearInterval(timeInterval);
        timeInterval = null;
        Dialog.confirm({
          title: "启动失败!",
          message: "充电枪断开，请确认充电枪插入没问题后再重新启动充电",
          confirmButtonText: "重新启动",
          confirmButtonColor: "#06A7FF",
        })
          .then(() => {
            timeCount.value = 120;
            countDown();
            lockReconnect = false;
            connectWebSoket(orderId);
          })
          .catch(() => {
            router.back();
            clearDataTools();
          });
        return;
      }
      timeCount.value--;
    }, 1000);
  }
}
function connectWebSoket(id) {
  let serverUrl = config.baseUrl.web_socket;
  if (serverUrl.indexOf("-webapp") != -1) {
    serverUrl = serverUrl.replace("-webapp", "-ws");
    serverUrl = serverUrl.replace("https", "wss");
  }
  let wsUrl = serverUrl + "?order_id=" + id;

  // 打开一个 web socket
  try {
    ws = new WebSocket(wsUrl);
    init();
  } catch (e) {
    reconnect(wsUrl);
  }

  function init() {
    ws.onclose = function () { };
    ws.onerror = function () {
      if (router.currentRoute.value.path.includes("staring_charging")) {
        reconnect(wsUrl);
      } else {
        console.log("服务器连接异常!");
      }
    };
    ws.onopen = function () {
      // ws.send("发送数据")
      Toast.clear();
    };
    ws.onmessage = function (event) {
      //拿到任何消息都说明当前连接是正常的
      let chargingData = JSON.parse(event.data);
      console.log("socket---",event.data)
      if (chargingData && chargingData.status == "charging") {
        setTimeout(function () {
          clearDataTools();
          router.replace(`/station/charging/${id}`);
        }, 2000);
      }
    };
  }
  function reconnect() {
    if (lockReconnect) {
      return;
    }
    lockReconnect = true;
    //没连接上会一直重连，设置延迟避免请求过多
    tt && clearTimeout(tt);
    tt = setTimeout(function () {
      lockReconnect = false;
      connectWebSoket(orderId);
    }, 5000);
  }
}
function clearDataTools() {
  Toast.clear();
  // 安全关闭WebSocket连接
  if (ws && ws.readyState === WebSocket.OPEN) {
    ws.close();
  }
  // 清除重连定时器
  if (tt) {
    clearTimeout(tt);
    tt = null;
  }
  // 关掉计时器
  if (timeInterval) {
    clearInterval(timeInterval);
    timeInterval = null;
  }
}
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  text-align: center;
}

.dot {
  width: 80px;
  height: 80px;
  margin-top: 30px;
}

.row-layout {
  display: flex;
}

.m-t-20 {
  margin-top: 20px;
}

.time {
  justify-content: center;
}

.f60-0082ff {
  font-size: 60px;
  color: #0082ff;
}

.unit-second {
  font-size: 16px;
  color: #0082ff;
}

.t-f14-c66 {
  font-size: 14px;
  color: #666;
  display: flex;
  justify-content: center;
}

.start_icon_div {
  margin-top: 60px;
  text-align: left;
}

.start_icon_view {
  width: 100%;
  margin-top: 60px;
  box-sizing: border-box;
}

.block_v {
  position: relative;
  display: flex;
  flex-direction: row;
  border-radius: 10px;
  align-items: center;
  padding: 0 20px;
  margin: 0 20px;
}

.first {
  background: linear-gradient(to left, #e0e6ee, #f8f9fb);
  height: 100px;
  box-sizing: border-box;
}

.t-f16-c40465c {
  font-size: 16px;
  color: #40465c;
  font-weight: bold;
}

.tip_icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.first_i {
  width: 110px;
  height: 100px;
  right: 0;
}

.t-f16-cff {
  font-size: 16px;
  color: #fff;
  font-weight: bold;
}

.t-f14-cFFF1EC {
  font-size: 14px;
  color: #fff1ec;
}

.second {
  background: linear-gradient(to left, #f8695d, #ffbda4);
  padding: 15px;
  margin-top: 15px;
}

.second_i {
  width: 88px;
  height: 88px;
  right: 10px;
}

.t-f14-c9FA1AB {
  font-size: 14px;
  color: #9fa1ab;
}
</style>